<template>
  <span v-if="index != null">
    <div class="ui dimmer modals page transition visible active">
      <div class="ui basic modal popupModal transition visible active">
        <div class="ui icon header">
          <i :class="icon" class="icon"></i>
          <span v-html="text"></span>
        </div>
        <div class="actions">
          <div
            v-if="cancel_text"
            :class="cancel_class"
            @click="$emit('cancel')"
          >
            {{ cancel_text }}
          </div>
          <div :class="confirm_class" @click="$emit('delete', index)">
            <i class="checkmark icon"></i>
            {{ confirm_text }}
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<style scoped>
.popupModal {
  margin-top: -100px;
}

.actions {
  text-align: center;
}
</style>

<script>
export default {
  name: 'PopupModal',
  props: {
    text: {
      type: String,
      default: ''
    },
    confirm_text: {
      type: String,
      default: 'Yes'
    },
    cancel_text: {
      type: String,
      default: 'No'
    },
    index: {
      // eslint-disable-next-line no-bitwise
      type: Number | Object,
      default: null
    },
    confirm_class: {
      type: String,
      default: ''
    },
    cancel_class: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// PopupModal.vue?240a2110